<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-text class="text--primary">
            <case-form ref="case-create-form"
                       :patient="patient"
                       @validation-changed="handleFormValidationChanged"
            ></case-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="handleResetButtonClick">
              Clear
            </v-btn>
            <v-btn color="primary" class="ml-3" :loading="progress('createCase')" :disabled="!createButtonActive"
                   @click="handleCreateButtonClick">
              Create
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import CaseForm from '../Components/CaseForm'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'CreateCase',
  components: {
    CaseForm
  },
  data() {
    const patientContext = this.$store.state.pgtCases.patientContext
    const patient = _.cloneDeep(patientContext)

    if (patient !== null) {
      this.setPatientContext(null)
    }

    return {
      formValid: false,
      patient: patient
    }
  },
  computed: {
    ...mapGetters('pgtCases', {
      progress: 'progress'
    }),
    createButtonActive() {
      return this.formValid && !this.progress('createCase')
    }
  },
  methods: {
    ...mapActions({
      getSystemId: 'pgtCases/getAvailableSystemId',
      createCase: 'pgtCases/createCase',
      getCases: 'pgtCases/getCases',
      setPatientContext: 'pgtCases/setPatientContext'
    }),
    handleFormValidationChanged(value) {
      this.formValid = value
    },
    handleResetButtonClick(value) {
      this.$refs['case-create-form'].reset()
    },
    async handleCreateButtonClick() {
      const caseData = this.$refs['case-create-form'].getFormData()
      const createdCase = await this.createCase(caseData)

      if (createdCase) {
        this.$router.push(`/cases/pgt/update/${createdCase.systemId}`)
      }
    }
  },
  async mounted() {
    this.formValid = this.$refs['case-create-form'].isValid()
  },
}
</script>

<style scoped>

</style>